/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  areasGet,
  areasAdd,
  areasUpdate,
  areasDelete,
} from "../../services/areas";
import { getValues } from "../../reducers/loginReducer";
import TableComponent from "../../components/Table/areas";
import ModalAdd from "./Modals/ModalAdd";
import { toast } from "react-hot-toast";
import ModalUpdate from "./Modals/ModalUpdate";

const columns = ["Nombre"];
const dataGet = ["nombre"];
export default function Index() {
  const dispatch = useDispatch();
  const { token } = useSelector(getValues);
  const [Data, setData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openUpdate, setopenUpdate] = React.useState(false);
  const [dataUpdate, setDataUpdate] = React.useState({});

  const openModal = () => {
    setOpen(true);
  };

  useEffect(() => {
    dispatch(setTitle("Descargando areas"));
    dispatch(showLoader());
    getInfo();
    return () => {};
  }, []);

  const getInfo = async () => {
    const response = await areasGet(token);
    dispatch(hideLoader());
    dispatch(setTitle("Listado de areas"));
    setData(response.data);
  };

  const openModalUpdateData = (data) => {
    setDataUpdate(data);
    setopenUpdate(true);
  };

  const saveInfo = (data) => {
    const save = async () => {
      const info = await areasAdd(data, token);
      if (info?.success === true) {
        setOpen(false);
        toast.success("Area guardado con exito");
        getInfo();
      } else {
        toast.error("Error al guardar el Area");
      }
    };
    save();
  };

  const updateInfo = (data) => {
    const save = async () => {
      const info = await areasUpdate(data, token);
      if (info?.success === true) {
        setopenUpdate(false);
        toast.success("Area actualizado con exito");
        getInfo();
      } else {
        toast.error("Error al actualizar el Area");
      }
    };
    save();
  };

  const deleteDato = async (id) => {
    const info = await areasDelete(
      {
        id,
      },
      token
    );
    if (info?.success === true) {
      toast.success("Area eliminado con exito");
      getInfo();
    } else {
      toast.error("Error al eliminar el Area");
    }
  };

  return (
    <div className="container mt-5">
      {open && <ModalAdd open={open} setOpen={setOpen} saveInfo={saveInfo} />}
      {openUpdate && (
        <ModalUpdate
          open={openUpdate}
          setOpen={setopenUpdate}
          saveInfo={updateInfo}
          data={dataUpdate}
        />
      )}
      <TableComponent
        title="Listado de areas"
        data={Data ?? []}
        columns={columns}
        dataGet={dataGet}
        deleteDato={deleteDato}
        openModal={openModal}
        updateData={openModalUpdateData}
      />
    </div>
  );
}
